import { FlexyFilterWrapperProps } from '../DatatableHeader';

export const FlexyFilterCollapsed: React.FunctionComponent<FlexyFilterWrapperProps> = function (
    props,
) {
    const { children } = props;

    return children;
};
